import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import moment from 'moment';
import {
  Form,
  Row,
  Col,
  Modal,
  Icon
} from 'antd';

const css = require('./index.scss');
const FormItem = Form.Item;

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    userId?: string;
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        const securityMgr = this.modulesState.securityMgr;
        const nickName = this.modulesState.userInfo && this.modulesState.userInfo.nickName;
        return (
            <div className={css['safe']}>
                <Row>
                    <Col 
                        span={10}
                        className={css['safe-block']}
                    >
                        <h4>上次更改密码时间</h4>
                        <span className={css['safe-text']}>
                            { securityMgr.passLastModifyTime ? moment(securityMgr.passLastModifyTime).format('YYYY-MM-DD HH:mm:ss') : '暂无'}
                        </span>
                    </Col>
                    <Col 
                        span={10}
                        className={css['safe-block']}
                    >
                        <h4>下次更改密码时间</h4>
                        <span className={css['safe-text']}>
                            { securityMgr.passNextModifyTime ? moment(securityMgr.passNextModifyTime).format("YYYY-MM-DD HH:mm:ss") : '暂无'}
                        </span>
                    </Col>
                    <Col 
                        span={14}
                        className={css['safe-block']}
                    >
                        {
                            securityMgr.locked ? 
                            <div>
                                <h4>账号状态</h4>
                                <span className={css['safe-text']}>该用户被系统锁定 <a onClick={() => { ModulesAction.updateDisabledUnlock(true); }}>点击解锁</a></span>
                            </div> :
                            <div>
                                <h4>账号状态</h4>
                                <span className={css['safe-text']}>正常</span>
                            </div>
                        }
                    </Col>
                </Row>
                <Modal
                    title="提示"
                    visible={this.modulesState.disabledUnlock}
                    onOk={this.unlock}
                    onCancel={this.disabledModalCancel}
                    className='kts-app-ant-modal'
                >
                    <p><Icon type="zhuyi"/>你确认要解锁企业用户{nickName}吗？</p>
                </Modal>
            </div>
        );
    }

    private unlock = () => {
        const userId = this.props.userId;
        ModulesAction.userUnlock({ userId })
        .then(res => {
            if (res) {
                ModulesAction.updateSecurityMgr({ userId });
                ModulesAction.updateDisabledUnlock(false);
            }
        });
    }

    private disabledModalCancel = () => {
        ModulesAction.updateDisabledUnlock(false);
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/UserManage/UI.Safe.tsx